import type { VueConstructor } from 'vue';
import OtLogo from './OtLogo.vue';
import PasswordRecoveryForm from './password-recovery/PasswordRecoveryForm.vue';
import PasswordRecoveryConfirmation from './password-recovery/PasswordRecoveryConfirmation.vue';
import HeaderCentered from './HeaderCentered.vue';
import LoginForm from './LoginForm.vue';

export function registerComponents(app: VueConstructor): void {
    app.component('OtLogo', OtLogo);
    app.component('PasswordRecoveryForm', PasswordRecoveryForm);
    app.component('PasswordRecoveryConfirmation', PasswordRecoveryConfirmation);
    app.component('HeaderCentered', HeaderCentered);
    app.component('LoginForm', LoginForm);
}
